import { Button, ButtonProps, Image } from 'antd';
import React, { useState } from 'react';

const ImageButton: React.FC<{ src: string; buttonProps?: ButtonProps }> = ({
  src,
  buttonProps,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Button onClick={() => setIsModalVisible(true)} {...buttonProps}>
        查看照片
      </Button>
      <Image
        src={src}
        hidden
        preview={{
          visible: isModalVisible,
          onVisibleChange: (visible) => setIsModalVisible(visible),
        }}
      />
    </div>
  );
};

export default ImageButton;
